var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx_dialog_toiast_delltet",attrs:{"id":"login_container"}},[_c('div',{staticClass:"wx_dialog_button_delete",on:{"click":_vm.close_wchat_qrcode}},[_c('i',{staticClass:"el-icon-close",staticStyle:{"font-size":"26px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }